<template>
  <div class="indexer mb-1">
    <div class="d-flex">
      <button class="btn btn-primary" type="button" @click="asListClicked">
        Add as List
      </button>
    </div>
  </div>
</template>
<script>
export default {
  emits: ["as-list"],
  methods: {
    asListClicked: function () {
      this.$emit("as-list");
    },
  },
};
</script>